import Fill from "../../api/model/snapshots/layers/Fill";
import { colorEquals, gradientEquals } from "./color";

function equals(fill: Fill, otherFill: Fill): boolean {
    if (
        fill.fillType !== otherFill.fillType ||
        fill.opacity !== otherFill.opacity ||
        fill.blendMode !== otherFill.blendMode
    ) {
        return false;
    }

    if (fill.fillType === "color" && otherFill.fillType === "color") {
        return colorEquals(fill.color!, otherFill.color!);
    }

    if (fill.fillType === "gradient" && otherFill.fillType === "gradient") {
        return gradientEquals(fill.gradient!, otherFill.gradient!);
    }

    return false;
}

export { equals };
